import React from "react";
import { Button, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';

export default class SiteFinder extends React.Component {
    dialogRef = React.createRef();
    state = {
        loading: false,
        page: 0,
        searchPhrase: '',
        itemList: [],
        selectedList: []
    };

    componentDidMount() {
        this.updateList();
    }

    async updateList() {
        this.setState({ loading: true });
        let list = await context.makeRequest("Admin.getSites", {
            phrase: this.state.searchPhrase,
            page: this.state.page,
            pageSize: this.state.pageSize || 15
        });
        //console.log(list);

        this.setState({ itemList: list.result?.items || [], loading: false });
    }

    selectUser(usr) {
        let list = this.state.selectedList;

        if (this.props.multiSelect !== false) {
            let alreadyOnList = list.find((li) => li.id === usr.id);

            if (!alreadyOnList) {
                list.push(usr);
            }
        } else {
            list = [ usr ];
        }

        this.setState({
            selectedList: list
        });
    }

    removeUser(usr) {
        let list = this.state.selectedList.filter((li) => li.id !== usr.id );

        this.setState({
            selectedList: list
        });
    }

    render() {
        return (
            <Modal
                onHide={ () => this.props.onClose() }
                centered={ true }
                backdrop={ 'static' } show={true}
                ref={ this.dialogRef }
                size={'xl'}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Select</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ flexDirection: 'row' }}>
                    <div style={ { float: 'left', width: 500 } }>
                        <Form.Group>
                            <Form.Label>Find</Form.Label>
                            <Form.Control 
                                type="text"
                                value={ this.state.searchPhrase }
                                onChange={ (event) => {
                                    this.setState({ searchPhrase: event.target.value }, () => {
                                        if (this.throttler)
                                            clearTimeout(this.throttler);
                                        this.throttler = setTimeout(() => this.updateList(), 1000);
                                    })
                                }}
                            />
                        </Form.Group>
                        <div style={{ height: 300, overflowY: 'auto' }}>
                        {
                            this.state.itemList.length > 0 ? this.state.itemList.map((itm) => {
                                return (
                                    <div style={{ width: '100%', padding: 15 }} 
                                        onClick={ () => this.selectUser(itm) }
                                        key={ itm.uuid }
                                    >
                                        <div style={{ width: '100%', padding: 5 }} 
                                            key={ "topRow" }
                                        >
                                            <div style={ { float: 'left' } }>
                                                { itm.name }
                                            </div>
                                            <div style={ { float: 'right' } }>
                                                { itm.uuid }
                                            </div>
                                        </div>
                                        <div style={{ width: '100%', padding: 5 }} 
                                            key={ "botRow" }
                                        >
                                            <div style={ { float: 'left' } }>
                                                { itm.address + ", " + itm.city }
                                            </div>
                                        </div>
                                    </div>
                                );
                            }) : ( this.state.loading ? "Loading" : "None found" )
                        }
                        </div>
                    </div>
                    <div style={ { float: 'right', width: 250, height: '100%' } }>
                        Selected<br/>
                        <div style={{ height: '100%', overflowY: 'auto' }}>
                            {
                                this.state.selectedList.length > 0 ? this.state.selectedList.map((usr) => {
                                    return (
                                        <div style={{ width: '100%', padding: 5 }} key={ usr.uuid }>
                                            <div style={ { float: 'left' } }>
                                                { usr.name }<br/>
                                                { usr.email }
                                            </div>
                                            <div style={ { float: 'right' } }>
                                                <Button variant="danger" onClick={ () => {
                                                    this.removeUser(usr);
                                                }}>X</Button>
                                            </div>
                                        </div>
                                    );
                                }) : "None selected"
                            }
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                        onClick={ () => this.props.onClose() }
                    >Close</Button>
                    <Button variant="primary"
                        disabled={ this.state.selectedList.length === 0 }
                        onClick={ () => this.props.onSave(this.state.selectedList) }
                    >Save</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}